import Component from './component.js';

/**
 * Минимальная реализация паттерна
 * [ListBox]{@link https://www.w3.org/WAI/ARIA/apg/patterns/listbox/}
 *
 * Позволяет перемещаться по дочерним элементам с помощью «стрелок» на
 * клавиатуре. Действие над выбранным дочерним элементом производится клавишей
 * «пробел» или «enter».
 */
class ListBox extends Component {
    constructor() {
        super();
        this.addEventListener('keydown', this.onKeyDown);
        this.addEventListener('click', this.onClick);
    }

    connectedCallback() {
        this.role = 'listbox';
        this.selectedIndex = 0;
    }

    /**
     * @type {HTMLElement[]}
     */
    get options() {
        // @ts-ignore
        return [...this.querySelectorAll('[class*=option]')];
    }

    /**
     * @type {HTMLElement}
     */
    get selectedOption() {
        return this.querySelector('._selected');
    }

    set selectedOption(target) {
        this.options.forEach((option) => {
            const isTarget = option === target;
            option.classList.toggle('_selected', isTarget);
            option.role = 'option';
            option.ariaSelected = String(isTarget);
            option.tabIndex = -1;
        });
        this.scrollToSelectedOption();
    }

    get selectedIndex() {
        return this.options.indexOf(this.selectedOption);
    }

    set selectedIndex(index) {
        const {options} = this;
        const newIndex = (options.length + index) % options.length;
        this.selectedOption = options.at(newIndex);
    }

    scrollToSelectedOption() {
        const option = this.selectedOption;
        if (option) {
            const optionTop = option.offsetTop + option.offsetHeight / 2;
            const top = optionTop - this.offsetHeight / 2;
            this.scroll(0, top);
        }
    }

    /**
     * @param {KeyboardEvent} event
     */
    onKeyDown(event) {
        switch (event.key) {
            case 'ArrowUp':
                this.selectedIndex -= 1;
                event.preventDefault();
                break;
            case 'ArrowDown':
                this.selectedIndex += 1;
                event.preventDefault();
                break;
            case ' ':
            case 'Enter':
                this.selectedOption.click();
                event.preventDefault();
                break;
        }
    }

    /**
     * @param {KeyboardEvent & {target: Element}} event
     */
    onClick(event) {
        /**
         * @type {HTMLElement}
         */
        const option = event.target.closest('[class*=option]');
        if (option) {
            this.selectedOption = option;
            this.dispatchEvent(new Event('option'));
        }
    }
}

customElements.define('list-box', ListBox);
export default ListBox;
